export default "__VITE_ASSET__4bic_3Xo__"